module.exports = __webpack_public_path__ + "static/img/compensate.0bf21433.png";